var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.24,283.08H309.55V64.82H458.24Zm-144.69-4H454.24V68.82H313.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.84,
    y: 69.87,
    width: 4,
    height: 211.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 72.91,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 79.18,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 85.44,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 91.71,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 97.98,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 104.24,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 110.51,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 116.77,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.92,
    y: 123.04,
    width: 155.95,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.99,
    y: 71.78,
    width: 1,
    height: 128.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.26 204.82 447.71 204.82 448.61 199.73 450.38 199.73 451.26 204.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.59,
    y: 71.78,
    width: 1,
    height: 175.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.87 251.26 451.32 251.26 452.21 246.16 453.98 246.16 454.87 251.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.71,
    y: 64.04,
    width: 168.36,
    height: 11.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.79,
    y: 64.09,
    width: 81.91,
    height: 99.36,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.15,
    y: 73.15,
    width: 63.19,
    height: 81.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.15,
    y: 73.15,
    width: 2.47,
    height: 81.22,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.7,
    y: 64.09,
    width: 2.47,
    height: 99.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.32,
    y: 84.35,
    width: 14.9,
    height: 44.39,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05,136.83H77.32V114.08h40.73Zm-39.73-1h38.73V115.08H78.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.15,
    y: 169.07,
    width: 81.91,
    height: 99.36,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.51,
    y: 178.14,
    width: 63.19,
    height: 81.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.51,
    y: 178.14,
    width: 2.47,
    height: 81.22,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.07,
    y: 169.07,
    width: 2.47,
    height: 99.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.99,
    y: 199.13,
    width: 12.77,
    height: 32.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,241.5H185.4V218.25h35.3Zm-34.3-1h33.3V219.25H186.4Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.76 422.76 85.57 422.52 140.38 422.43 250 422.27 359.62 422.43 414.43 422.52 469.24 422.76 414.43 423.01 359.62 423.1 250 423.26 140.38 423.1 85.57 423.01 30.76 422.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.38,322.39l-5.64-9.48.2,0-3.06,1.82A2.84,2.84,0,0,1,462,315a2.8,2.8,0,0,1-.88-.35l-.77-.43-.77-.43a2.84,2.84,0,0,1-.76-.58,2.87,2.87,0,0,1-.78-1.75l0-3.56.29.29-11,.08.37-.37,0,3.57A3.07,3.07,0,0,1,446.1,314l-.76.44-.75.44a2.93,2.93,0,0,1-.95.39,3,3,0,0,1-2-.23l-3.1-1.77.6-.16-5.48,9.56-.17-.64,3.09,1.79a3,3,0,0,1,1.23,1.65,3,3,0,0,1,.14,1l0,.88,0,.87a3.25,3.25,0,0,1-.14,1,3,3,0,0,1-1.23,1.66l-3.09,1.8.19-.68,5.48,9.56-.65-.17,3.11-1.77a3,3,0,0,1,2-.24,3.37,3.37,0,0,1,1,.4l.75.44.75.43a3,3,0,0,1,.82.64,3.06,3.06,0,0,1,.81,1.87v3.57l-.44-.44,11,0-.39.39,0-3.57a3,3,0,0,1,.8-1.81,2.85,2.85,0,0,1,.79-.6l.76-.44.77-.43a3,3,0,0,1,.92-.37,2.91,2.91,0,0,1,1.94.24l3.07,1.79-.4.11,5.61-9.49.06.25-3-1.82a2.73,2.73,0,0,1-1.06-1.48,5.7,5.7,0,0,1-.07-1.79,5.37,5.37,0,0,1,.12-1.78,2.62,2.62,0,0,1,1.07-1.42Zm0,0-3,1.81a2.55,2.55,0,0,0-1,1.38,5.3,5.3,0,0,0-.07,1.74,5.8,5.8,0,0,0,.11,1.73,2.43,2.43,0,0,0,1,1.31l3.08,1.73.16.09-.1.16-5.41,9.6-.14.26-.26-.15-3.07-1.73a2.24,2.24,0,0,0-1.51-.16,2.11,2.11,0,0,0-.71.3l-.77.45-.77.46a2.16,2.16,0,0,0-.61.47,2.26,2.26,0,0,0-.58,1.37l0,3.52v.4h-.4l-11,0h-.44v-.44l0-3.51a2.17,2.17,0,0,0-.57-1.32,2.12,2.12,0,0,0-.59-.44l-.78-.45-.77-.45a2.15,2.15,0,0,0-2.1-.11l-3,1.76-.41.24-.24-.41-5.53-9.54-.25-.43.43-.25,3.05-1.76a2.05,2.05,0,0,0,.84-1.12,2.5,2.5,0,0,0,.1-.72l0-.9,0-.9a2.19,2.19,0,0,0-.09-.72,2.06,2.06,0,0,0-.84-1.14l-3-1.77-.4-.23.23-.41,5.53-9.53.22-.38.38.22,3,1.76a2.17,2.17,0,0,0,1.44.17,2.09,2.09,0,0,0,.69-.28l.78-.45.78-.44a2.42,2.42,0,0,0,.6-.45,2.21,2.21,0,0,0,.59-1.34l0-3.52v-.38h.37l11,.08h.3v.29l0,3.52a2.3,2.3,0,0,0,.62,1.44,2.36,2.36,0,0,0,.63.5l.76.45.77.46a2.27,2.27,0,0,0,.75.32,2.36,2.36,0,0,0,1.59-.16l3.09-1.72.12-.07.07.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.84,327.32A9.28,9.28,0,0,1,446.12,334a9.28,9.28,0,0,1,6.69-16,9.27,9.27,0,0,1,9,9.28Zm0,0a8.76,8.76,0,0,0-9-8.78,8.78,8.78,0,1,0,9,8.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.15,271.4l-5.63-9.47.19.05-3.06,1.81a2.85,2.85,0,0,1-2.74-.12l-.77-.43-.76-.43a2.74,2.74,0,0,1-.77-.58,2.87,2.87,0,0,1-.78-1.75l0-3.56.29.29-11,.08.37-.37,0,3.57a3,3,0,0,1-.79,1.85,3.19,3.19,0,0,1-.8.62l-.76.44-.75.44a2.93,2.93,0,0,1-1,.39,3,3,0,0,1-2-.22l-3.1-1.78.6-.16-5.48,9.56-.17-.63,3.09,1.78a3.07,3.07,0,0,1,1.23,1.65,3,3,0,0,1,.14,1l0,.87,0,.88a3.32,3.32,0,0,1-.14,1,3.09,3.09,0,0,1-1.23,1.66l-3.09,1.8.19-.68,5.48,9.56-.65-.18,3.11-1.77a3,3,0,0,1,2-.23,3.08,3.08,0,0,1,1,.39l.75.44.75.44a2.81,2.81,0,0,1,.82.63,3,3,0,0,1,.81,1.87v3.57l-.44-.43,11,0-.39.39,0-3.56a3,3,0,0,1,.8-1.82,3.3,3.3,0,0,1,.79-.6l.76-.43.77-.44a3,3,0,0,1,2.86-.13l3.07,1.8-.4.11,5.61-9.5.06.25-3-1.81a2.73,2.73,0,0,1-1.06-1.48,5.77,5.77,0,0,1-.07-1.8,5.39,5.39,0,0,1,.12-1.78,2.6,2.6,0,0,1,1.07-1.41Zm0,0-3,1.81a2.55,2.55,0,0,0-1,1.38,5.33,5.33,0,0,0-.07,1.74,5.8,5.8,0,0,0,.11,1.73,2.49,2.49,0,0,0,1,1.32l3.08,1.73.16.09-.1.16L68.89,291l-.14.25-.26-.14-3.07-1.74a2.3,2.3,0,0,0-1.51-.16,2.34,2.34,0,0,0-.71.3l-.77.45-.77.46a2.16,2.16,0,0,0-.61.47,2.29,2.29,0,0,0-.58,1.38l0,3.51v.4h-.4l-11,0h-.44v-.45l0-3.51a2.12,2.12,0,0,0-.57-1.31,2.37,2.37,0,0,0-.59-.45l-.78-.45-.77-.45a2.1,2.1,0,0,0-.68-.27,2.16,2.16,0,0,0-1.42.16l-3,1.76-.41.24-.24-.41-5.53-9.53-.25-.44.43-.25,3.05-1.75a2.08,2.08,0,0,0,.84-1.13,2.5,2.5,0,0,0,.1-.72l0-.9,0-.9a2.19,2.19,0,0,0-.09-.72,2.14,2.14,0,0,0-.84-1.14l-3-1.77-.4-.23.23-.4,5.53-9.53.22-.39.38.22,3,1.77a2.23,2.23,0,0,0,1.44.16,2.09,2.09,0,0,0,.69-.28l.78-.45.78-.44a2.42,2.42,0,0,0,.6-.45,2.16,2.16,0,0,0,.59-1.34l0-3.52v-.37h.37l11,.08h.3v.29l0,3.53a2.32,2.32,0,0,0,.62,1.44,2.54,2.54,0,0,0,.63.49l.76.46.77.45a2.27,2.27,0,0,0,.75.32,2.3,2.3,0,0,0,1.59-.16l3.09-1.72.12-.07.07.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.61,276.33A9.29,9.29,0,1,1,61,269.9,9.31,9.31,0,0,1,63.61,276.33Zm0,0a8.78,8.78,0,0,0-17.56,0,8.78,8.78,0,1,0,17.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48,216.72a4.89,4.89,0,0,1,3.58,3.64c.12.48.25,1,.4,1.45s.31,1,.47,1.45a4.83,4.83,0,0,1-1,5l-4.3,4.58,14.9,14,4.33-4.6A4.83,4.83,0,0,1,90.81,241a28.44,28.44,0,0,0,2.9.69A4.9,4.9,0,0,1,97.58,245l1.81,6L119,245.09l-1.81-6a4.92,4.92,0,0,1,1.36-4.95c.72-.7,1.4-1.42,2-2.18a4.83,4.83,0,0,1,4.79-1.66l6.16,1.44,4.66-19.91L130,210.4a4.81,4.81,0,0,1-3.54-3.54q-.19-.77-.42-1.53c-.15-.51-.32-1-.5-1.51a4.78,4.78,0,0,1,1-4.93l4.3-4.57-14.9-14-4.28,4.57a4.81,4.81,0,0,1-4.84,1.33,26.5,26.5,0,0,0-3.17-.74,4.77,4.77,0,0,1-3.72-3.35l-1.81-6L78.57,182l1.81,6A4.91,4.91,0,0,1,79,193a28,28,0,0,0-2,2.18,4.86,4.86,0,0,1-4.81,1.66L66,195.39l-4.67,19.9Zm24.39-18.43a16.75,16.75,0,1,1-9.63,18A16.77,16.77,0,0,1,91.87,198.29Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.14,212.79c-2.27.31-12.16-.74-18.67,8.31-6.16,8.56-8.1,34.45-9.38,40.1s-8.67,6.56-10.35,13.12c-1.44,5.65,2.68,7.67,3.14,11.8.35,3.2-2.82,8,.14,12.74,2.7,4.29,7.37,3.33,10.2,4.65s4.66,7.84,9.9,9.56,9.81-3.1,12.58-3.1,6.14,8.48,15.18,7.65,11.58-8.51,15.3-10.06,13.12,1,17.36-3.73,4.91-10.95,6.82-13.26,5.94-2,8.29-7.32S207,274.6,206.29,270c-.52-3.2,2.3-6.18.25-11.06-2.82-6.71-11-5.19-14.26-12.08-2.51-5.4-7.84-28.94-22.15-34.62C160.25,208.33,149.14,212.79,149.14,212.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.35,259.84A8.18,8.18,0,0,1,119,262.9L116,265.47a24.38,24.38,0,0,0-5.16,5.55,7.8,7.8,0,0,0-.8,6.88A11.8,11.8,0,0,0,112,281a13.94,13.94,0,0,1,2.26,3.41,6.68,6.68,0,0,1-.32,4.26c-.41,1.26-.87,2.45-1.21,3.67a9.21,9.21,0,0,0,.31,7.08,5.29,5.29,0,0,0,2.49,2.41,9.72,9.72,0,0,0,3.62.75c1.27.08,2.57,0,3.87,0a6.58,6.58,0,0,1,3.78.82A7,7,0,0,0,123,303c-1.28.11-2.57.27-3.89.3a10.19,10.19,0,0,1-4-.61A6.39,6.39,0,0,1,112,300c-1.55-2.42-1.3-5.49-.61-8,.34-1.29.79-2.52,1.15-3.73a5.43,5.43,0,0,0,.29-3.34c-.8-2.06-3.15-3.88-4.06-6.56a8.75,8.75,0,0,1,1.11-8,25,25,0,0,1,5.66-5.5l3.13-2.31A8.91,8.91,0,0,0,121.35,259.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,225.42c2.51,4,4.08,8.36,6.06,12.53,1,2.09,1.91,4.21,3,6.18a15.09,15.09,0,0,0,1.89,2.72,2.14,2.14,0,0,0,.54.51,2.89,2.89,0,0,0,.62.4c.49.25,1,.48,1.53.7a66.84,66.84,0,0,1,6.4,2.89,11.9,11.9,0,0,1,5.14,5.06,7.38,7.38,0,0,1,.76,3.62,9.6,9.6,0,0,1-1,3.46,14.92,14.92,0,0,0-2.1,6.51c-.31-2.35.61-4.67,1.43-6.79a8.79,8.79,0,0,0,.76-3.22,6.45,6.45,0,0,0-.83-3.07,11.57,11.57,0,0,0-4.79-4.39,66,66,0,0,0-6.32-2.71c-.54-.24-1.08-.49-1.62-.78a5.36,5.36,0,0,1-1.54-1.23,16.35,16.35,0,0,1-2-3,55.37,55.37,0,0,1-2.91-6.39L186,231.88A62.85,62.85,0,0,0,183.44,225.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56,289c-1,1.34-1.09,3.08-1.45,4.68s-.67,3.26-1.09,4.88a24.35,24.35,0,0,1-1.69,4.81,11.06,11.06,0,0,1-3.28,4.14c-3.14,2-6.89,1.85-10.14,1.28-1.66-.28-3.28-.66-4.9-.91a10.28,10.28,0,0,0-4.87.07,9.62,9.62,0,0,1,5-.79c1.68.11,3.33.36,5,.5,3.21.32,6.64.33,9.15-1.37a9.74,9.74,0,0,0,2.87-3.56,30.7,30.7,0,0,0,1.86-4.49c.54-1.55,1-3.15,1.47-4.74.26-.79.52-1.59.83-2.37A4.77,4.77,0,0,1,203.56,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,317.69c8,33.5,25,75.55,37.26,83.85,9.88,6.7,61.16,17.74,64,18,7.06.55,19.85-49.51,12.51-51.36-9.25-2.35-53-2.73-55.55-5.23s-22.8-29.58-41.37-54.14C170.74,291.83,160,289.91,166.69,317.69Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,416.92c.85.41,12.89,6.13,20.3,8.1,5.53,1.47,21.57,5.28,23.79-.65,1.52-4-7.64-7.39-14.07-9.9-3.39-1.32-7.6-4.74-6.66-6.92,1.64-3.81,10.37-.22,16.12,2.95,11.13,6.14,26,17.3,32.6,11.58,2.49-2.16-.54-5.93-4.94-9.6,7.09,4.23,14.63,7.66,17.49,5.36,1.64-1.3,1.68-3,.7-5,2.18.65,4.08.47,5.38-1,2.22-2.43,1-5.91-1.53-9.45a2.74,2.74,0,0,0,2-1.41c4.65-7.44-19.91-28-28.28-29.75-24.64-5.28-50.66-2.57-50.66-2.57C265.07,376.58,262.23,416.9,262.25,416.92Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,393.56a41.58,41.58,0,0,1,16.49,5.92c6.3,4,10.53,8.67,15.85,13.39.14.12-.05.34-.19.22-2.53-2.24-13-10.65-15.72-12.55a39.57,39.57,0,0,0-16.45-6.88C297.7,393.65,297.72,393.55,297.78,393.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.11,383.06c6.48,1.61,13.12,3.25,19.17,6.16,6.62,3.19,11.86,8.51,17,13.62q4.63,4.62,9.07,9.43c.12.13-.06.35-.19.22q-7.85-7.94-16.16-15.39a52.23,52.23,0,0,0-17.58-10.54c-3.72-1.32-7.53-2.36-11.34-3.39C302,383.15,302,383,302.11,383.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.79,373.81c6.29,1.14,11.77,2.12,17.39,5.35,7.43,4.27,14.68,11.6,17.23,14.19,2.81,2.87,5.52,5.83,8.18,8.83.11.12-.1.31-.21.19a210.29,210.29,0,0,0-19.51-18.48,41.34,41.34,0,0,0-10.83-6.7,75.06,75.06,0,0,0-12.26-3.34S308.76,373.8,308.79,373.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57,365.12l8.9,60.69s-62.21-10.47-76.19-25-33-61.26-35.88-89.29,4.3-25.67,20.54-5.27,39.17,52.36,42.25,54.15S266.57,365.12,266.57,365.12Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86,332.76l-.27.06,0-.13ZM233,402.88a2,2,0,0,1,1,.28,1.78,1.78,0,0,1,.87,1.49,2.29,2.29,0,0,0,1.39,2.12,4,4,0,0,0,2.38-.09c-.38-.1-.75-.14-1.13-.21a1.88,1.88,0,0,1-.94-.31,1.78,1.78,0,0,1-.81-1.53,2.28,2.28,0,0,0-1.48-2.09,4.44,4.44,0,0,0-2.36.12C232.29,402.76,232.67,402.81,233,402.88Zm37.63-9.83a6.56,6.56,0,0,0-1.79.24c.38.1.76.14,1.13.21a2.3,2.3,0,0,1,.75.17ZM202.47,378a1.87,1.87,0,0,1,.95.28,1.76,1.76,0,0,1,.87,1.48,2.3,2.3,0,0,0,1.4,2.13,4,4,0,0,0,2.37-.09c-.37-.1-.75-.14-1.12-.22a1.84,1.84,0,0,1-.94-.3,1.81,1.81,0,0,1-.82-1.53,2.28,2.28,0,0,0-1.47-2.09,4.47,4.47,0,0,0-2.37.12C201.72,377.88,202.09,377.93,202.47,378Zm-14.1-14.63a2,2,0,0,1-.87.48,1.76,1.76,0,0,1-1.67-.44,2.27,2.27,0,0,0-2.49-.51c-.87.38-1.18,1.13-1.62,1.74.34-.2.64-.43,1-.64a1.82,1.82,0,0,1,2.53.05,2.28,2.28,0,0,0,2.52.44,4.49,4.49,0,0,0,1.59-1.76C189,362.92,188.69,363.16,188.37,363.37Zm46,4.27a1.93,1.93,0,0,1-.88.48,1.77,1.77,0,0,1-1.66-.43,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.18,1.13-1.62,1.74.34-.19.64-.43.95-.64a1.86,1.86,0,0,1,.88-.45,1.78,1.78,0,0,1,1.66.5,2.26,2.26,0,0,0,2.52.44,4.43,4.43,0,0,0,1.59-1.76C234.94,367.19,234.64,367.43,234.33,367.64Zm-16.93,32a2,2,0,0,1-.88.48,1.74,1.74,0,0,1-1.66-.43,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.19,1.13-1.62,1.74.34-.19.63-.43.95-.64a1.81,1.81,0,0,1,.88-.45,1.79,1.79,0,0,1,1.66.51,2.27,2.27,0,0,0,2.52.43,4.4,4.4,0,0,0,1.58-1.76C218,399.21,217.71,399.45,217.4,399.66Zm36.08-7a2.08,2.08,0,0,1-.88.48,1.77,1.77,0,0,1-1.66-.44,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.19,1.13-1.62,1.74.34-.19.63-.42.95-.64a1.9,1.9,0,0,1,.88-.45,1.81,1.81,0,0,1,1.66.51,2.29,2.29,0,0,0,2.52.44,4.42,4.42,0,0,0,1.58-1.77C254.09,392.21,253.79,392.44,253.48,392.66Zm-83.27-85.79a2,2,0,0,1-.27,1,1.76,1.76,0,0,1-1.49.86,2.3,2.3,0,0,0-2.13,1.4,4.11,4.11,0,0,0,.09,2.37c.1-.37.15-.75.22-1.12a1.87,1.87,0,0,1,.3-.94,1.81,1.81,0,0,1,1.53-.82,2.25,2.25,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C170.33,306.12,170.29,306.49,170.21,306.87Zm22.3,82.8c-.1.38-.15.75-.22,1.13a2.35,2.35,0,0,1-.12.64l.43.67,0-.07A4.47,4.47,0,0,0,192.51,389.67Zm63.7-19.58a2,2,0,0,1-.27,1,1.77,1.77,0,0,1-1.49.87,2.31,2.31,0,0,0-2.13,1.4,4.11,4.11,0,0,0,.09,2.37c.1-.38.15-.75.22-1.13a1.87,1.87,0,0,1,.3-.94,1.8,1.8,0,0,1,1.54-.81,2.26,2.26,0,0,0,2.08-1.47,4.37,4.37,0,0,0-.12-2.37C256.33,369.34,256.29,369.72,256.21,370.09ZM260,412.52a2,2,0,0,1-.28,1,1.8,1.8,0,0,1-1.49.87,2.27,2.27,0,0,0-2.12,1.39,4,4,0,0,0,.09,2.38c.1-.38.14-.75.21-1.13a1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.26,2.26,0,0,0,2.09-1.47,4.33,4.33,0,0,0-.13-2.36C260.14,411.77,260.1,412.15,260,412.52Zm-29.78-28.34a2,2,0,0,1-.28,1,1.76,1.76,0,0,1-1.49.86,2.28,2.28,0,0,0-2.12,1.4,4,4,0,0,0,.08,2.37,11.07,11.07,0,0,0,.22-1.12,1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.27,2.27,0,0,0,2.09-1.47,4.37,4.37,0,0,0-.13-2.37C230.36,383.43,230.32,383.8,230.25,384.18Zm-41.7-42.95a2,2,0,0,1-.28,1,1.8,1.8,0,0,1-1.49.87,2.27,2.27,0,0,0-2.12,1.39,4,4,0,0,0,.09,2.38c.1-.38.14-.75.21-1.13a1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.26,2.26,0,0,0,2.09-1.47,4.33,4.33,0,0,0-.13-2.36C188.66,340.48,188.62,340.86,188.55,341.23Zm22.14,19.26a2,2,0,0,1-.28,1,1.76,1.76,0,0,1-1.49.86,2.28,2.28,0,0,0-2.12,1.4,4,4,0,0,0,.09,2.37c.1-.37.14-.75.21-1.12a1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.27,2.27,0,0,0,2.09-1.47,4.37,4.37,0,0,0-.13-2.37C210.8,359.74,210.76,360.11,210.69,360.49ZM185.4,322a1.9,1.9,0,0,1,.87-.48,1.74,1.74,0,0,1,1.66.44,2.31,2.31,0,0,0,2.49.51c.87-.38,1.19-1.13,1.62-1.74-.34.19-.63.43-.95.64a1.81,1.81,0,0,1-.88.45,1.78,1.78,0,0,1-1.66-.5,2.26,2.26,0,0,0-2.52-.44,4.4,4.4,0,0,0-1.58,1.76C184.78,322.48,185.08,322.24,185.4,322Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,419.49c0-3.41-.72-6.91-1.09-10.31s-.89-7-1.39-10.52c-1-6.81-2.18-13.61-3.38-20.39-.7-3.95-1.55-7.87-2.3-11.81,0-.14-.26-.11-.25,0,.83,6.95,1.58,13.9,2.54,20.83s2,13.63,3.23,20.42c.35,1.94.77,3.86,1.14,5.8a59,59,0,0,0,1.24,6A.13.13,0,0,0,261.59,419.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,418.81c-17.36-4.43-36.52-10.7-43.54-18-14-14.52-33-61.26-35.88-89.29-1.52-14.66-.27-21,3.58-20.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47,378l5.77,44.49H94.79C98,370,128.46,312.66,141.88,296.31c6.72-8.19,20-9.94,30.08-3.26,2.39,1.58,30.15,42.66,32.5,48.63C213.13,363.71,202.47,378,202.47,378Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.14,328.74a4.47,4.47,0,0,1,2.37-.12,2.27,2.27,0,0,1,1.47,2.09,1.81,1.81,0,0,0,.82,1.53,1.87,1.87,0,0,0,.94.3c.37.08.75.12,1.12.22a4,4,0,0,1-2.37.09,2.3,2.3,0,0,1-1.4-2.13,1.75,1.75,0,0,0-.86-1.48,1.94,1.94,0,0,0-1-.28C161.89,328.89,161.52,328.84,161.14,328.74Zm8.5,47.29a1.9,1.9,0,0,1,1,.28,1.76,1.76,0,0,1,.87,1.48,2.3,2.3,0,0,0,1.4,2.13,4,4,0,0,0,2.37-.09c-.38-.1-.75-.14-1.13-.22a1.87,1.87,0,0,1-.94-.3,1.78,1.78,0,0,1-.81-1.53,2.26,2.26,0,0,0-1.47-2.09,4.47,4.47,0,0,0-2.37.12C168.89,375.91,169.27,376,169.64,376Zm-27.8-31.39a1.9,1.9,0,0,1,1,.28,1.78,1.78,0,0,1,.87,1.48,2.27,2.27,0,0,0,1.39,2.13,4,4,0,0,0,2.37-.09c-.37-.1-.75-.14-1.12-.22a1.87,1.87,0,0,1-.94-.3,1.81,1.81,0,0,1-.82-1.53,2.27,2.27,0,0,0-1.47-2.09,4.47,4.47,0,0,0-2.37.12C141.09,344.52,141.47,344.57,141.84,344.64Zm-15.07,48.21a2,2,0,0,1,1,.27,1.77,1.77,0,0,1,.87,1.49,2.3,2.3,0,0,0,1.4,2.13,4.11,4.11,0,0,0,2.37-.09c-.38-.1-.75-.15-1.13-.22a1.82,1.82,0,0,1-1.75-1.84,2.26,2.26,0,0,0-1.47-2.08,4.47,4.47,0,0,0-2.37.12C126,392.73,126.39,392.77,126.77,392.85Zm67.84,23.41a1.87,1.87,0,0,1,.95.28,1.76,1.76,0,0,1,.87,1.48,2.3,2.3,0,0,0,1.4,2.13,4,4,0,0,0,2.37-.09c-.38-.1-.75-.14-1.13-.22a1.8,1.8,0,0,1-.93-.3,1.77,1.77,0,0,1-.82-1.53,2.26,2.26,0,0,0-1.47-2.09,4.47,4.47,0,0,0-2.37.12C193.85,416.14,194.23,416.18,194.61,416.26Zm-95-17.57a1.88,1.88,0,0,1-1-.3,1.84,1.84,0,0,1-.58-.63c-.06.33-.13.65-.19,1a1.93,1.93,0,0,0,.46.26,4.14,4.14,0,0,0,2.38-.09A11.07,11.07,0,0,0,99.65,398.69ZM150.12,295a2,2,0,0,1,1,.28,1.75,1.75,0,0,1,.86,1.48,2.3,2.3,0,0,0,1.4,2.13,4,4,0,0,0,2.37-.09c-.37-.1-.75-.14-1.12-.22a1.87,1.87,0,0,1-.94-.3,1.81,1.81,0,0,1-.82-1.53,2.27,2.27,0,0,0-1.47-2.09,4.47,4.47,0,0,0-2.37.12C149.37,294.85,149.74,294.9,150.12,295Zm38.25,68.4a2,2,0,0,1-.87.48,1.76,1.76,0,0,1-1.67-.44,2.27,2.27,0,0,0-2.49-.51c-.87.38-1.18,1.13-1.62,1.74.34-.2.64-.43,1-.64a1.82,1.82,0,0,1,2.53.05,2.28,2.28,0,0,0,2.52.44,4.49,4.49,0,0,0,1.59-1.76C189,362.92,188.69,363.16,188.37,363.37Zm-72.92-15a1.89,1.89,0,0,1-.87.48,1.81,1.81,0,0,1-1.24-.14c-.11.27-.22.54-.32.81a2.21,2.21,0,0,0,1.8,0,4.49,4.49,0,0,0,1.59-1.76C116.07,347.9,115.77,348.13,115.45,348.35Zm0,32.37a2,2,0,0,1-.88.48,1.74,1.74,0,0,1-1.66-.43,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.19,1.13-1.62,1.74.34-.19.63-.43,1-.64a1.81,1.81,0,0,1,.88-.45,1.79,1.79,0,0,1,1.66.51,2.27,2.27,0,0,0,2.52.43,4.4,4.4,0,0,0,1.58-1.76C116.07,380.27,115.77,380.51,115.46,380.72Zm31.44,32.71a1.9,1.9,0,0,1-.87.48,1.77,1.77,0,0,1-1.67-.44,2.28,2.28,0,0,0-2.49-.51c-.86.38-1.18,1.13-1.61,1.74.33-.2.63-.43,1-.64a1.81,1.81,0,0,1,.88-.45,1.78,1.78,0,0,1,1.66.5,2.26,2.26,0,0,0,2.51.44,4.42,4.42,0,0,0,1.59-1.76C147.51,413,147.22,413.22,146.9,413.43Zm2.36-39.69a2,2,0,0,1-.87.48,1.77,1.77,0,0,1-1.66-.44,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.19,1.13-1.62,1.74.34-.19.63-.42.95-.64a1.9,1.9,0,0,1,.88-.45,1.81,1.81,0,0,1,1.66.51,2.29,2.29,0,0,0,2.52.44,4.42,4.42,0,0,0,1.58-1.77C149.88,373.29,149.58,373.52,149.26,373.74Zm26.66,33a2,2,0,0,1-.87.48,1.8,1.8,0,0,1-1.67-.44,2.27,2.27,0,0,0-2.49-.51c-.86.38-1.18,1.13-1.61,1.74.33-.2.63-.43.95-.65a1.88,1.88,0,0,1,.88-.44,1.78,1.78,0,0,1,1.66.5,2.26,2.26,0,0,0,2.51.44,4.42,4.42,0,0,0,1.59-1.76C176.53,406.26,176.24,406.5,175.92,406.71Zm-5.71-99.84a2,2,0,0,1-.27,1,1.76,1.76,0,0,1-1.49.86,2.3,2.3,0,0,0-2.13,1.4,4.11,4.11,0,0,0,.09,2.37c.1-.37.15-.75.22-1.12a1.87,1.87,0,0,1,.3-.94,1.81,1.81,0,0,1,1.53-.82,2.25,2.25,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C170.33,306.12,170.29,306.49,170.21,306.87Zm22.08,83.93a1.87,1.87,0,0,1-.28.95,1.76,1.76,0,0,1-1.48.87,2.3,2.3,0,0,0-2.13,1.4,4,4,0,0,0,.09,2.37c.1-.37.14-.75.22-1.13a1.82,1.82,0,0,1,1.83-1.75,2.26,2.26,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C192.41,390.05,192.36,390.42,192.29,390.8Zm-3.74-49.57a2,2,0,0,1-.28,1,1.8,1.8,0,0,1-1.49.87,2.27,2.27,0,0,0-2.12,1.39,4,4,0,0,0,.09,2.38c.1-.38.14-.75.21-1.13a1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.26,2.26,0,0,0,2.09-1.47,4.33,4.33,0,0,0-.13-2.36C188.66,340.48,188.62,340.86,188.55,341.23Zm-23.36,12.44a1.87,1.87,0,0,1-.28.95,1.76,1.76,0,0,1-1.48.87,2.3,2.3,0,0,0-2.13,1.4,4,4,0,0,0,.09,2.37c.1-.37.14-.75.22-1.13a1.82,1.82,0,0,1,1.83-1.75,2.28,2.28,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C165.31,352.92,165.26,353.29,165.19,353.67ZM114.4,408.18a2,2,0,0,1-.28.95,1.77,1.77,0,0,1-1.49.87,2.28,2.28,0,0,0-2.12,1.4,4,4,0,0,0,.09,2.37c.1-.38.14-.75.21-1.13a1.88,1.88,0,0,1,.31-.94,1.77,1.77,0,0,1,1.53-.81,2.28,2.28,0,0,0,2.09-1.47,4.37,4.37,0,0,0-.13-2.37C114.51,407.42,114.47,407.8,114.4,408.18Zm16.39-78.61a1.9,1.9,0,0,1-.28,1,1.76,1.76,0,0,1-1.48.87,2.28,2.28,0,0,0-2.13,1.4,4,4,0,0,0,.09,2.37c.1-.38.14-.75.22-1.13a1.87,1.87,0,0,1,.3-.94,1.78,1.78,0,0,1,1.53-.81,2.28,2.28,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C130.91,328.82,130.86,329.2,130.79,329.57Zm0,32.89a1.9,1.9,0,0,1-.28,1,1.78,1.78,0,0,1-1.48.87,2.29,2.29,0,0,0-2.13,1.39,4.06,4.06,0,0,0,.09,2.38c.1-.38.14-.75.22-1.13a1.87,1.87,0,0,1,.3-.94,1.81,1.81,0,0,1,1.53-.82,2.26,2.26,0,0,0,2.09-1.47,4.43,4.43,0,0,0-.12-2.36C130.91,361.71,130.86,362.09,130.79,362.46Zm26.44,28.34a2,2,0,0,1-.28.95,1.77,1.77,0,0,1-1.49.87,2.28,2.28,0,0,0-2.12,1.4,4,4,0,0,0,.08,2.37,10.74,10.74,0,0,0,.22-1.13,1.81,1.81,0,0,1,.31-.93,1.78,1.78,0,0,1,1.53-.82,2.28,2.28,0,0,0,2.09-1.47,4.37,4.37,0,0,0-.13-2.37C157.34,390.05,157.3,390.42,157.23,390.8ZM185.4,322a1.9,1.9,0,0,1,.87-.48,1.74,1.74,0,0,1,1.66.44,2.31,2.31,0,0,0,2.49.51c.87-.38,1.19-1.13,1.62-1.74-.34.19-.63.43-.95.64a1.81,1.81,0,0,1-.88.45,1.78,1.78,0,0,1-1.66-.5,2.26,2.26,0,0,0-2.52-.44,4.4,4.4,0,0,0-1.58,1.76C184.78,322.48,185.08,322.24,185.4,322ZM145,318.67a2,2,0,0,1,.88-.48,1.77,1.77,0,0,1,1.66.43,2.29,2.29,0,0,0,2.49.52c.87-.38,1.19-1.13,1.62-1.74-.34.19-.64.43-1,.64a1.81,1.81,0,0,1-.88.45,1.78,1.78,0,0,1-1.66-.5,2.26,2.26,0,0,0-2.52-.44,4.5,4.5,0,0,0-1.59,1.76C144.39,319.12,144.69,318.88,145,318.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,372.61a35.84,35.84,0,0,0,1.93-21c-1.27-5.74-3.95-11.05-6.88-16.1-.5-.86-1.5-2.45-2.71-4.34-1.07-2.33-2.23-4.61-3.44-6.88-.07-.12-.24,0-.18.12.67,1.46,1.35,2.91,2.06,4.35-2.84-4.35-6.16-9.33-7.43-11.12a.1.1,0,0,0-.17.1c1.33,2.93,8.09,13.59,9.64,16.37,2.85,5.12,5.58,10.43,7.07,16.13a34.51,34.51,0,0,1-2.64,24.81,7.73,7.73,0,0,0-1,4.1c.09,1.6.36,3.2.56,4.79.46,3.64,1,7.27,1.47,10.9s.94,7.19,1.72,10.7c.05.22.38.15.38-.06-.09-3.31-.49-6.63-.85-9.92s-.73-6.45-1.1-9.67c-.19-1.65-.4-3.31-.61-5-.09-.72-.21-1.45-.23-2.17a5.14,5.14,0,0,1,.6-2.33C205,375.16,205.66,373.92,206.2,372.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.23,301.43C121.15,313.89,67,360,70.2,376.36c3.27,16.58,15.82,30,25.47,20.71,8-7.63,43.33-64.26,49.74-79.41C151.51,303.24,151,289.2,136.23,301.43Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.85,371.79c0,11.47,7.68,33.12,22.61,29.09,9.78-2.64,50.34-69.49,56.88-85.35,7.57-18.38,1-25.59-12.94-14.76S68.87,355.38,68.85,371.79Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,323.7a4,4,0,0,1-2.37.09,1.38,1.38,0,0,1-.34-.18c.19-.16.37-.32.56-.5l.08.07a1.87,1.87,0,0,0,.94.3C110.21,323.56,110.59,323.6,111,323.7ZM94,362.91a2,2,0,0,1,1,.27,1.8,1.8,0,0,1,.87,1.49,2.29,2.29,0,0,0,1.39,2.13,4.15,4.15,0,0,0,2.38-.09c-.38-.1-.75-.15-1.13-.22a1.87,1.87,0,0,1-.94-.3,1.79,1.79,0,0,1-.81-1.54,2.26,2.26,0,0,0-1.48-2.08,4.43,4.43,0,0,0-2.36.12C93.21,362.79,93.59,362.83,94,362.91Zm2.46,31.86a4.47,4.47,0,0,0-2.37.12,10.71,10.71,0,0,0,1.13.21,2.12,2.12,0,0,1,.95.28,1.85,1.85,0,0,1,.84,1.18l.65-.7A2.07,2.07,0,0,0,96.42,394.77Zm19-46.42a2.08,2.08,0,0,1-.88.48,1.77,1.77,0,0,1-1.66-.44,2.27,2.27,0,0,0-2.49-.51c-.87.38-1.19,1.13-1.62,1.74.34-.2.63-.43,1-.65a1.85,1.85,0,0,1,2.54.06,2.28,2.28,0,0,0,2.52.44,4.46,4.46,0,0,0,1.58-1.76C116.07,347.9,115.77,348.14,115.46,348.35Zm17.59-43.46a2,2,0,0,1-.28,1,1.8,1.8,0,0,1-1.49.87,2.27,2.27,0,0,0-2.12,1.39,4,4,0,0,0,.09,2.37c.1-.37.14-.75.21-1.12a1.88,1.88,0,0,1,.31-.94,1.8,1.8,0,0,1,1.53-.82,2.27,2.27,0,0,0,2.09-1.47,4.37,4.37,0,0,0-.13-2.37C133.16,304.14,133.12,304.51,133.05,304.89Zm-2.26,24.68a1.9,1.9,0,0,1-.28,1,1.76,1.76,0,0,1-1.48.87,2.28,2.28,0,0,0-2.13,1.4,4,4,0,0,0,.09,2.37c.1-.38.14-.75.22-1.13a1.87,1.87,0,0,1,.3-.94,1.78,1.78,0,0,1,1.53-.81,2.28,2.28,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C130.91,328.82,130.86,329.2,130.79,329.57ZM83.41,382.19a2,2,0,0,1-.28,1,1.75,1.75,0,0,1-1.49.86,2.29,2.29,0,0,0-2.12,1.4,4,4,0,0,0,.09,2.37c.1-.37.14-.75.22-1.12a1.78,1.78,0,0,1,.3-.94,1.81,1.81,0,0,1,1.53-.82,2.27,2.27,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C83.53,381.44,83.48,381.81,83.41,382.19Zm62.24-64.65a4.44,4.44,0,0,0-1.59,1.77c.33-.2.62-.43.94-.64a2,2,0,0,1,.88-.48,1.79,1.79,0,0,1,1.21.12c.14-.27.26-.53.38-.79A2.18,2.18,0,0,0,145.65,317.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.69,338.64c-1.35,1.87-2.84,3.66-4.28,5.47l-1,1.29c.9-1.72,1.77-3.46,2.64-5.21a81.53,81.53,0,0,0,3.53-7.73c.06-.17-.2-.25-.28-.11-1.35,2.12-2.44,4.38-3.71,6.54s-2.51,4.35-3.74,6.54c-2.46,4.37-5,8.71-7.58,13-5.22,8.56-10.77,16.93-16.51,25.15-1.6,2.3-3.2,4.62-4.88,6.86s-3.28,4.7-5,7c-.06.08,0,.18.11.11,1.62-2,3.29-3.87,4.94-5.8s3.11-3.93,4.64-5.9c3.09-4,6-8.08,8.86-12.23a298.47,298.47,0,0,0,15.81-25.87c.13-.23.24-.45.36-.68.81-.88,1.62-1.77,2.38-2.71,1.43-1.78,2.66-3.69,3.92-5.6C138.91,338.63,138.76,338.55,138.69,338.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.87,289.59s3.31,13.56-.65,15.43c-7.37,3.49-20.54-7.34-21.39-9.29-.22-.49-1.31-13.52-2.14-23.65-.53-6.51-.95-11.83-.95-11.83l25.76,10.24-.59,17.83Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,270.49l-.59,17.83a35.77,35.77,0,0,1-24.22-16.24c-.53-6.51-.95-11.83-.95-11.83l3.23,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,250.77c.1,7.29,5.37,13.13,11.77,13s11.5-6.07,11.4-13.37-5.37-13.13-11.77-13S175,243.48,175.05,250.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,251.28c.12,8.12,6,14.61,13.1,14.51s12.79-6.76,12.68-14.87-6-14.61-13.1-14.51S171.19,243.17,171.3,251.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,246.19c1.16,31.27-17.44,35.5-24.18,35.74-6.12.23-27,.2-31.39-30.79s9.78-41.41,23.76-42.66S192.06,214.91,193.23,246.19Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,240.28a18.43,18.43,0,0,1-2.11-.47,3.51,3.51,0,0,1-2.06-.89,1.11,1.11,0,0,1,0-1.36,2.74,2.74,0,0,1,2.72-.61,4,4,0,0,1,2.53,1.46A1.19,1.19,0,0,1,185.5,240.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,241.06a18.81,18.81,0,0,0,2.1-.49,3.46,3.46,0,0,0,2.06-.9,1.13,1.13,0,0,0,0-1.36,2.78,2.78,0,0,0-2.73-.6A4.07,4.07,0,0,0,164,239.2,1.19,1.19,0,0,0,165.08,241.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,248.87c0-.08-.16.11-.16.2.17,2.12,0,4.58-1.88,5.38-.06,0,0,.13,0,.12C170.5,254.13,170.68,250.86,170.18,248.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,246.74c-3.44-.1-3.37,6.78-.19,6.87S171.05,246.82,168.17,246.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.82,247.11c-.59.4-1.18,1.09-1.9,1.17s-1.48-.62-2-1.31c-.06-.07-.12,0-.12.08,0,1.32.51,2.66,1.93,2.85s2.2-1,2.52-2.34C167.28,247.32,167.06,247,166.82,247.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.57,248c0-.08.16.1.16.19-.06,2.13.22,4.58,2.15,5.29.06,0,.05.13,0,.12C181.51,253.24,181.16,250,181.57,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.47,245.75c3.42-.27,3.7,6.6.53,6.85S180.59,246,183.47,245.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,246.14c.56.34,1.12,1,1.77,1s1.28-.75,1.73-1.48c.05-.08.11,0,.11.07.09,1.31-.29,2.7-1.54,3s-2-.82-2.4-2.11C184.52,246.38,184.69,246,184.92,246.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,265.42c.49.52,1,1.22,1.75,1.32a5.76,5.76,0,0,0,2.31-.45.07.07,0,0,1,.09.11,2.92,2.92,0,0,1-2.75,1.06,2.3,2.3,0,0,1-1.61-1.95C170.16,265.39,170.32,265.35,170.39,265.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.14,257.54s.5,3.17.54,4.67c0,.14-.36.21-.87.25,0,0,0,0-.06,0a7.14,7.14,0,0,1-7-2.52.15.15,0,0,1,.22-.21,10.78,10.78,0,0,0,6.56,1.73c.1-.42-1-5.41-.81-5.43a13.1,13.1,0,0,1,3.42.7c-.86-6.64-2.78-13.09-3.54-19.71a.21.21,0,0,1,.39-.11c2.49,6.62,3.65,14.24,4.72,21.07C182.86,258.84,179.74,257.78,179.14,257.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,261.68a7.91,7.91,0,0,1-3,2.68,3.57,3.57,0,0,1-2.13.3c-1.58-.29-1.73-1.71-1.54-3a8.33,8.33,0,0,1,.55-1.92A10.17,10.17,0,0,0,177.8,261.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84,264.36a3.57,3.57,0,0,1-2.13.3c-1.58-.29-1.73-1.71-1.54-3C172.84,261.75,174.58,262.75,174.84,264.36Z",
    style: {
      fill: "#f392b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,248.37c3.41.1,13.07-8.41,14.84-24.75,0,0-2.6,14.56-3.9,16.61s5.41-4.79,7-17.95c0,0,6.83,5.94,12.9,8.26s9.89,2.6,10.37,2.19-8.41-4.13-10.63-7.22c0,0,15.87,9.22,23.45,10.49.88.15-.6-13.5-11.71-22.29s-26.38-6.59-31.85-2.19c0,0-6,.31-13.2,8.46S134.56,248.25,138.23,248.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,253.36s-6.34-10.09-10.89-7.88-.11,16.61,5,18.8a5.28,5.28,0,0,0,7.22-2.49Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,249.58a.07.07,0,0,0,0,.13c3.57,1.66,5.32,5.13,6.5,8.71-1-1.41-2.46-2.22-4.33-1-.1.06,0,.22.09.2a3.27,3.27,0,0,1,3.52,1.31,15.69,15.69,0,0,1,1.57,3c.16.34.75.19.65-.19l0-.09C141.46,257,138.17,250.29,133.21,249.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,263.05a1.09,1.09,0,1,1-2.18-.17,1.09,1.09,0,0,1,2.18.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,260.93a.68.68,0,0,1-.74.63.7.7,0,0,1-.64-.74.71.71,0,0,1,.75-.64A.69.69,0,0,1,136.9,260.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.89,251.69l-2.16.37a.45.45,0,0,1-.51-.36h0a.44.44,0,0,1,.36-.51l2.16-.36a.44.44,0,0,1,.51.36h0A.44.44,0,0,1,131.89,251.69Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,250.3l-2.19,0a.44.44,0,0,1-.44-.43h0a.44.44,0,0,1,.42-.45l2.19,0a.42.42,0,0,1,.45.42h0A.44.44,0,0,1,131.7,250.3Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.56,245.6s-2-15.83,2.13-24.88c4.6-10.07,25-17.8,40.29-8.17,0,0-23.63-5.7-34,8.5-4.36,6-3.13,24.66-3.13,24.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.92,252.75c.56,8.1-4.74,15.06-11.84,15.55s-13.32-5.67-13.88-13.77,4.74-15.05,11.85-15.54S151.36,244.66,151.92,252.75Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.14,252.55c.51,7.28-4.26,13.54-10.64,14s-12-5.1-12.47-12.38,4.26-13.53,10.64-14S147.64,245.28,148.14,252.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.21 274.52 153.86 272.25 144.34 264.17 145.59 262.7 154.74 270.47 164.62 272.64 164.21 274.52",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9,273.2c.39-3,8.39-3.44,7.79,1S162.5,276.17,162.9,273.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,291A109,109,0,0,0,137,299.59s20.08,20.24,32.29,17.75,5.52-21.54,5.52-21.54S166.8,285.36,153.05,291Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,395.6c-9.27,11.33-24.38-1.61-26.1-11.7-4-23.66,1.16-67.07,8.06-87.64,2.22-6.63,46.19,6,46.29,13.45C125.4,317.52,115.87,372.61,97,395.6Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.82,308.16s.66-21.73,8.39-36.21c5.34-10,19.4-30.5,53.24-31.95,8-.34,19.71,4.86,6.8,10.19-9.16,3.78-16.12,3.4-21,6.57,0,0,14.07,8.39,14.1,16.44a147.6,147.6,0,0,1-1.42,21.06,32.94,32.94,0,0,1-4,.09s-.21,7.54-8.63,15.36Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84,263.21c5.56-2.11,17.42-6.39,28.34-6.51,12.13-.14,35.53,2.86,35.54,11.81,0,6.57-9,6.21-9,6.21s9.41,3.28,8.12,9.21c-1.17,5.41-8.15,4.71-8.15,4.71s5.37,3,3.23,8c-2.56,6-13.39-1.21-21.25,2.62C127.88,300.08,92.84,263.21,92.84,263.21Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19,269.54c5.55-1.13,18.83-.46,28.38,5,.21.12.24.35,0,.28a119.27,119.27,0,0,0-28.4-5.13C119.12,269.65,119.12,269.55,119.19,269.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,281.78c4.9-.49,18.55.82,28,6.64.21.13.22.36,0,.29a127.74,127.74,0,0,0-28-6.82A.06.06,0,0,1,119.68,281.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.66,264.61c-1.32-1.46-3.19-2-4.83-3-.09-.05-.17.1-.07.14,2.88,1.21,5.91,4.07,5.43,7.46-.58,4.08-5.46,5.11-8.86,5.21-.17,0-.09.19.09.22,3.77.66,9.09-.65,9.78-5.09A5.92,5.92,0,0,0,155.66,264.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,274.29c-.1,0-.17.1-.08.14,5.23,2,8.44,5.63,8.71,7.68a5,5,0,0,1-2.32,5.2,8.84,8.84,0,0,1-6,.94c-.16,0-.23.22-.06.25,2.45.45,7.15,1,8.85-2.95C157.44,282.25,155.85,276.74,146.87,274.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,291a7.85,7.85,0,0,0-4.27-3c-.09,0-.14.11-.06.14,2.43,1,4.72,3.95,4.53,6.61-.1,1.36-1.07,4.15-7,3.83a44,44,0,0,1-4.75-.43c-1.07-.12-.45.25-.14.31,3.58.73,12.47,2.8,12.66-4.14A5.82,5.82,0,0,0,150.71,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,244.65c-.23-1.49-2.13-3-5.75-3.67,0,0,0,0,0,0,3,.82,5.19,2.43,5.17,3.9s-1.09,3-4.27,4.7c-.09,0,0,.1.07.06C149.44,248.78,152.77,247.35,152.35,244.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.56,299.9,130,318.22s-19.81,61-29.18,74.16-22.34,10.74-29.83-5.51S75.56,299.9,75.56,299.9Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.25,319.68a4.47,4.47,0,0,1,2.37-.12,2.26,2.26,0,0,1,1.47,2.09,1.78,1.78,0,0,0,.81,1.53,1.87,1.87,0,0,0,.94.3c.38.08.75.12,1.13.22a4,4,0,0,1-2.37.09,2.3,2.3,0,0,1-1.4-2.13,1.76,1.76,0,0,0-.87-1.48,1.9,1.9,0,0,0-1-.28C105,319.83,104.62,319.78,104.25,319.68ZM94,362.91a2,2,0,0,1,1,.27,1.8,1.8,0,0,1,.87,1.49,2.29,2.29,0,0,0,1.39,2.13,4.15,4.15,0,0,0,2.38-.09c-.38-.1-.75-.15-1.13-.22a1.87,1.87,0,0,1-.94-.3,1.79,1.79,0,0,1-.81-1.54,2.26,2.26,0,0,0-1.48-2.08,4.43,4.43,0,0,0-2.36.12C93.21,362.79,93.59,362.83,94,362.91Zm2.45,31.86a4.48,4.48,0,0,0-2.37.12c.38.1.76.15,1.13.22a1.93,1.93,0,0,1,1,.27,1.79,1.79,0,0,1,.85,1.3c.24-.21.48-.43.72-.67A2.15,2.15,0,0,0,96.41,394.77Zm19-46.42a2.08,2.08,0,0,1-.88.48,1.77,1.77,0,0,1-1.66-.44,2.27,2.27,0,0,0-2.49-.51c-.87.38-1.19,1.13-1.62,1.74.34-.2.63-.43,1-.65a1.85,1.85,0,0,1,2.54.06,2.28,2.28,0,0,0,2.52.44,4.46,4.46,0,0,0,1.58-1.76C116.07,347.9,115.77,348.14,115.46,348.35Zm-37,3.85a1.9,1.9,0,0,1-.87.48,1.77,1.77,0,0,1-1.67-.44,2.28,2.28,0,0,0-2.49-.51c-.86.38-1.18,1.13-1.61,1.74.33-.2.63-.43,1-.64a1.81,1.81,0,0,1,.88-.45,1.78,1.78,0,0,1,1.66.5,2.26,2.26,0,0,0,2.51.44,4.42,4.42,0,0,0,1.59-1.76C79,351.75,78.73,352,78.41,352.2Zm6.06-40.08a2,2,0,0,1-.88.48,1.74,1.74,0,0,1-1.66-.43,2.29,2.29,0,0,0-2.49-.52c-.87.38-1.18,1.13-1.62,1.74.34-.19.64-.43,1-.64a1.81,1.81,0,0,1,.88-.45,1.79,1.79,0,0,1,1.66.51,2.27,2.27,0,0,0,2.52.43,4.5,4.5,0,0,0,1.59-1.76C85.08,311.68,84.78,311.91,84.47,312.12Zm6.16,20.81a1.9,1.9,0,0,1-.28,1,1.76,1.76,0,0,1-1.48.87,2.28,2.28,0,0,0-2.13,1.4,4,4,0,0,0,.09,2.37c.1-.38.14-.75.22-1.13a1.87,1.87,0,0,1,.3-.94,1.78,1.78,0,0,1,1.53-.81A2.28,2.28,0,0,0,91,334.18a4.47,4.47,0,0,0-.12-2.37C90.75,332.18,90.7,332.56,90.63,332.93Zm-7.22,49.26a2,2,0,0,1-.28,1,1.75,1.75,0,0,1-1.49.86,2.29,2.29,0,0,0-2.12,1.4,4,4,0,0,0,.09,2.37c.1-.37.14-.75.22-1.12a1.78,1.78,0,0,1,.3-.94,1.81,1.81,0,0,1,1.53-.82,2.27,2.27,0,0,0,2.09-1.47,4.47,4.47,0,0,0-.12-2.37C83.53,381.44,83.48,381.81,83.41,382.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,328.41a90,90,0,0,0-9.08-3.57c-3.1-1.2-6.23-2.26-9.35-3.34-6.08-2.08-12.22-3.94-18.34-5.78-3.57-1.08-7.16-2-10.74-3-.13,0-.18.22-.05.26,6.15,2.31,12.27,4.69,18.45,6.85S107,324,113.09,325.78c1.75.52,3.52,1,5.27,1.46a44.91,44.91,0,0,0,5.46,1.45C124,328.71,124,328.48,123.88,328.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05,318.36c-.15-.5-6.18-2.06-6.49-2.16-.1,0-.13.12,0,.16.3.09,5.4,2.22,5.38,2.27-3,8-5.74,16.08-8.61,24.12s-5.84,16.1-8.56,24.22c-1.53,4.56-1.42,5,.2,1.09s3.28-7.14,4.76-11.12c3-8,5.82-16.13,8.62-24.23C127.91,328.12,131.1,318.52,131.05,318.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "467.95 422.69 400.78 422.69 389.04 373.94 456.21 373.94 467.95 422.69",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.11 422.69 444.28 422.69 456.01 373.94 388.84 373.94 377.11 422.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.27 383.1 444.78 389.33 444.69 389.71 443.14 396.18 443.05 396.56 441.5 403.02 441.4 403.4 439.85 409.87 439.76 410.25 438.24 416.59 388.93 416.59 390.44 410.25 390.54 409.87 392.09 403.4 392.18 403.02 393.73 396.56 393.83 396.18 395.38 389.71 395.47 389.33 396.96 383.1 446.27 383.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.19 383.1 402.69 389.33 402.6 389.71 401.05 396.18 400.96 396.56 399.41 403.02 399.32 403.4 397.76 409.87 397.67 410.25 396.15 416.59 395.76 416.59 397.28 410.25 397.37 409.87 398.92 403.4 399.01 403.02 400.56 396.56 400.65 396.18 402.21 389.71 402.3 389.33 403.79 383.1 404.19 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.21 383.1 409.71 389.33 409.62 389.71 408.07 396.18 407.98 396.56 406.43 403.02 406.34 403.4 404.79 409.87 404.69 410.25 403.18 416.59 402.78 416.59 404.3 410.25 404.4 409.87 405.94 403.4 406.04 403.02 407.59 396.56 407.68 396.18 409.23 389.71 409.32 389.33 410.81 383.1 411.21 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.24 383.1 416.74 389.33 416.65 389.71 415.1 396.18 415.01 396.56 413.46 403.02 413.37 403.4 411.81 409.87 411.72 410.25 410.2 416.59 409.81 416.59 411.33 410.25 411.42 409.87 412.97 403.4 413.06 403.02 414.61 396.56 414.71 396.18 416.26 389.71 416.35 389.33 417.84 383.1 418.24 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.26 383.1 423.77 389.33 423.67 389.71 422.13 396.18 422.03 396.56 420.48 403.02 420.39 403.4 418.84 409.87 418.75 410.25 417.23 416.59 416.83 416.59 418.36 410.25 418.45 409.87 420 403.4 420.09 403.02 421.64 396.56 421.73 396.18 423.28 389.71 423.38 389.33 424.87 383.1 425.26 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.29 383.1 430.79 389.33 430.7 389.71 429.15 396.18 429.06 396.56 427.51 403.02 427.42 403.4 425.87 409.87 425.78 410.25 424.26 416.59 423.86 416.59 425.38 410.25 425.48 409.87 427.02 403.4 427.12 403.02 428.67 396.56 428.76 396.18 430.31 389.71 430.4 389.33 431.89 383.1 432.29 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.31 383.1 437.82 389.33 437.73 389.71 436.18 396.18 436.09 396.56 434.54 403.02 434.44 403.4 432.89 409.87 432.8 410.25 431.28 416.59 430.89 416.59 432.41 410.25 432.5 409.87 434.05 403.4 434.14 403.02 435.69 396.56 435.78 396.18 437.33 389.71 437.43 389.33 438.92 383.1 439.31 383.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.78 389.33 444.69 389.71 395.38 389.71 395.47 389.33 444.78 389.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.14 396.18 443.05 396.56 393.73 396.56 393.83 396.18 443.14 396.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.5 403.02 441.4 403.4 392.09 403.4 392.18 403.02 441.5 403.02",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.85 409.87 439.76 410.25 390.44 410.25 390.54 409.87 439.85 409.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,396.83a10.94,10.94,0,0,0-2.41,1.79,4.2,4.2,0,0,0-1.4,2.49,1.65,1.65,0,0,0,.32,1.26A2.3,2.3,0,0,0,429,403a6.37,6.37,0,0,0,2.88-.07,6.57,6.57,0,0,0,2.62-1.22,3.48,3.48,0,0,0,.9-1.09,2.24,2.24,0,0,0,.29-1.32,1.72,1.72,0,0,0-.73-1.12,3.6,3.6,0,0,0-1.33-.57,6.18,6.18,0,0,0-3,0,5.84,5.84,0,0,1,3-.28,4,4,0,0,1,1.46.55,2.06,2.06,0,0,1,.93,1.32,2.48,2.48,0,0,1-.29,1.59,3.88,3.88,0,0,1-1,1.24,7.11,7.11,0,0,1-5.91,1.38,2.72,2.72,0,0,1-1.4-.82,1.71,1.71,0,0,1-.36-.77,2.82,2.82,0,0,1,0-.82,4.53,4.53,0,0,1,1.61-2.62A10.33,10.33,0,0,1,431.3,396.83Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.64 384.83 397.41 384.83 397.55 384.2 402.79 384.2 402.64 384.83",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.23 385.93 397.15 385.93 397.3 385.29 400.38 385.29 400.23 385.93",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.93 404.96 420.74 404.96 420.89 404.32 424.08 404.32 423.93 404.96",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.43 407.19 420.24 407.19 420.39 406.55 423.57 406.55 423.43 407.19",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.49 406.05 420.49 406.05 420.64 405.41 425.63 405.41 425.49 406.05",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.19 400.04 429 400.04 429.14 399.4 432.33 399.4 432.19 400.04",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.74 401.13 428.75 401.13 428.89 400.49 433.89 400.49 433.74 401.13",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.39,388.22l3.07-2.3a1.85,1.85,0,0,0,.71-1,1.18,1.18,0,0,0-.15-.94,1.09,1.09,0,0,0-.93-.46,1.77,1.77,0,0,0-1,.36l-.32.24c-.1.08-.22.07-.26,0a.18.18,0,0,1,.07-.26l.32-.25a2.27,2.27,0,0,1,1.31-.46,1.35,1.35,0,0,1,1.17.59,1.5,1.5,0,0,1,.2,1.19,2.43,2.43,0,0,1-.89,1.32l-2.64,2h2.58a.14.14,0,0,1,.14.19.26.26,0,0,1-.23.19h-3.07a.15.15,0,0,1-.12-.05A.21.21,0,0,1,389.39,388.22Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,395.17a4.43,4.43,0,0,1,1-1.91,2.24,2.24,0,0,1,1.55-.81,1.27,1.27,0,0,1,1.17.81,3.18,3.18,0,0,1,.09,1.91,4.44,4.44,0,0,1-1,1.9,2.23,2.23,0,0,1-1.56.83,1.27,1.27,0,0,1-1.17-.83A3.07,3.07,0,0,1,387.87,395.17Zm.38,0a2.76,2.76,0,0,0,.07,1.69,1,1,0,0,0,.89.65,1.73,1.73,0,0,0,1.19-.65,3.82,3.82,0,0,0,.86-1.69,2.68,2.68,0,0,0-.08-1.69,1,1,0,0,0-.89-.65,1.66,1.66,0,0,0-1.19.65A3.8,3.8,0,0,0,388.25,395.17Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,406.91l3.08-2.3a1.85,1.85,0,0,0,.71-1,1.22,1.22,0,0,0-.15-.94,1.11,1.11,0,0,0-.93-.46,1.77,1.77,0,0,0-1,.36l-.32.24a.17.17,0,0,1-.26,0,.19.19,0,0,1,.07-.26l.32-.25a2.32,2.32,0,0,1,1.32-.46,1.35,1.35,0,0,1,1.17.59,1.45,1.45,0,0,1,.19,1.19,2.37,2.37,0,0,1-.89,1.32l-2.63,2h2.57a.15.15,0,0,1,.15.19.27.27,0,0,1-.23.19h-3.07a.16.16,0,0,1-.13-.05A.22.22,0,0,1,385.07,406.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.55,413.86a4.43,4.43,0,0,1,1-1.91,2.24,2.24,0,0,1,1.56-.81,1.27,1.27,0,0,1,1.17.81,3.18,3.18,0,0,1,.09,1.91,4.46,4.46,0,0,1-1,1.9,2.23,2.23,0,0,1-1.55.83,1.27,1.27,0,0,1-1.17-.83A3.07,3.07,0,0,1,383.55,413.86Zm.38,0a2.84,2.84,0,0,0,.07,1.69,1,1,0,0,0,.9.65,1.73,1.73,0,0,0,1.19-.65,3.92,3.92,0,0,0,.86-1.69,2.83,2.83,0,0,0-.08-1.69,1,1,0,0,0-.89-.65,1.68,1.68,0,0,0-1.2.65A4,4,0,0,0,383.93,413.86Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.94,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.57-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.41.41,0,0,1-.45.38.42.42,0,0,1-.38-.45c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.48,1.41a2.36,2.36,0,0,0,.18,2.2.89.89,0,0,0,.71.34.42.42,0,0,1,.47.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,377.27a1.77,1.77,0,0,1-1.3-.64,3,3,0,0,1-.34-3c.47-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.27,2.28a.42.42,0,0,1-.84-.07c.07-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.43.43,0,0,1,.48.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.57-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.42.42,0,0,1-.45.38.43.43,0,0,1-.39-.45c.07-.77-.16-1.3-.58-1.38s-1.16.37-1.48,1.41a2.39,2.39,0,0,0,.17,2.2.91.91,0,0,0,.72.34.42.42,0,0,1,.47.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,377.27a1.77,1.77,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.27,2.28a.42.42,0,0,1-.84-.07c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.43.43,0,0,1,.48.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,377.27a1.79,1.79,0,0,1-1.3-.64,3,3,0,0,1-.33-3c.46-1.53,1.57-2.16,2.43-2,.67.13,1.39.8,1.27,2.28a.42.42,0,0,1-.45.38.42.42,0,0,1-.39-.45c.07-.77-.16-1.3-.58-1.38s-1.16.37-1.48,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.72.34.42.42,0,0,1,.47.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.41.41,0,0,1-.45.38.42.42,0,0,1-.38-.45c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.42.42,0,0,1,.47.36.4.4,0,0,1-.35.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,377.27a1.79,1.79,0,0,1-1.3-.64,3,3,0,0,1-.33-3c.46-1.53,1.57-2.16,2.43-2,.66.13,1.39.8,1.27,2.28a.42.42,0,0,1-.84-.07c.07-.77-.16-1.3-.58-1.38s-1.17.37-1.48,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.43.43,0,0,1,.48.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.57-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.42.42,0,1,1-.83-.07c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.48,1.41a2.36,2.36,0,0,0,.18,2.2.89.89,0,0,0,.71.34.42.42,0,0,1,.11.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.34,377.27a1.77,1.77,0,0,1-1.3-.64,3,3,0,0,1-.34-3c.47-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.27,2.28a.42.42,0,0,1-.84-.07c.07-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.43.43,0,0,1,.48.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.51,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.57-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.42.42,0,0,1-.45.38.43.43,0,0,1-.39-.45c.07-.77-.16-1.3-.58-1.38s-1.16.37-1.48,1.41a2.39,2.39,0,0,0,.17,2.2.91.91,0,0,0,.72.34.42.42,0,0,1,.47.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68,377.27a1.77,1.77,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.27,2.28a.42.42,0,0,1-.84-.07c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.43.43,0,0,1,.48.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.86,377.27a1.79,1.79,0,0,1-1.3-.64,3,3,0,0,1-.33-3c.46-1.53,1.57-2.16,2.43-2,.67.13,1.39.8,1.27,2.28a.42.42,0,0,1-.45.38.42.42,0,0,1-.39-.45c.07-.77-.16-1.3-.58-1.38s-1.16.37-1.48,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.72.34.42.42,0,0,1,.47.36.42.42,0,0,1-.36.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,377.27a1.75,1.75,0,0,1-1.29-.64,3,3,0,0,1-.34-3c.46-1.53,1.58-2.16,2.44-2,.66.13,1.39.8,1.26,2.28a.41.41,0,0,1-.45.38.42.42,0,0,1-.38-.45c.06-.77-.16-1.3-.59-1.38s-1.16.37-1.47,1.41a2.33,2.33,0,0,0,.17,2.2.89.89,0,0,0,.71.34.42.42,0,0,1,.47.36.4.4,0,0,1-.35.47Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.92,
    y: 423.81,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.82,
    y: 423.52,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.72,
    y: 423.22,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.62,
    y: 422.92,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.51,
    y: 422.63,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.41,
    y: 422.33,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.31,
    y: 422.03,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.21,
    y: 421.74,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.11,
    y: 421.44,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.65 430.87 237.24 430.87 237.24 425.42 318.65 423.15 318.65 430.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.11 409.37 263.71 409.37 285.09 309.31 419.48 309.31 398.11 409.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.08 409.37 268.68 409.37 290.06 309.31 424.45 309.31 403.08 409.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.18,353.55a10.1,10.1,0,0,1-9.62,8.3,6.92,6.92,0,0,1-7-8.3,10.12,10.12,0,0,1,9.63-8.31A6.91,6.91,0,0,1,358.18,353.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.07 435.5 298.97 435.5 298.97 430.37 365.07 428.23 365.07 435.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.04 435.5 347.55 435.5 326.18 379.43 361.67 379.43 383.04 435.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.88 435.5 353.39 435.5 332.02 379.43 367.51 379.43 388.88 435.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.73,436.87H166.58c-5.82,0,2.6-16.56,23.82-22.92S241.42,430.65,234.73,436.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,436.87a20.68,20.68,0,0,1,.93-5.56,23.6,23.6,0,0,1,2.3-5.19,18.64,18.64,0,0,1,3.61-4.4,16.29,16.29,0,0,1,4.8-3c-.74.6-1.57,1-2.24,1.68l-1,.89-1,1a24.49,24.49,0,0,0-3.31,4.35,32.6,32.6,0,0,0-2.41,4.93A41,41,0,0,0,208,436.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.06,421.11a39.42,39.42,0,0,1,5.88,2.4,40.93,40.93,0,0,1,5.48,3.25,24.61,24.61,0,0,1,4.75,4.31,15.09,15.09,0,0,1,1.76,2.7,8,8,0,0,1,.8,3.1A8.92,8.92,0,0,0,233.5,434a14,14,0,0,0-1.91-2.43,32.46,32.46,0,0,0-4.75-4c-1.69-1.23-3.47-2.31-5.27-3.4-.9-.54-1.81-1.05-2.73-1.55S217,421.61,216.06,421.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.7 117.56 141.7 117.56 141.7 117.6 138.7 117.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.76 117.71 153.81 118.03 153.79 118.21 147.75 117.82 147.76 117.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.85 118.53 165.87 119.22 165.83 119.55 159.82 118.79 159.85 118.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.87 120.08 177.85 121.13 177.75 121.61 171.81 120.49 171.87 120.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.78 122.38 189.68 123.82 189.54 124.35 183.66 122.89 183.78 122.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.52 125.43 201.32 127.22 201.13 127.79 195.36 125.98 195.52 125.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.06 129.19 212.74 131.33 212.5 131.93 206.85 129.77 207.06 129.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.34 133.64 223.88 136.12 223.58 136.75 218.07 134.26 218.34 133.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.34 138.77 234.72 141.58 234.36 142.24 229.01 139.41 229.34 138.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.01 144.55 245.2 147.69 244.78 148.37 239.61 145.22 240.01 144.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.31 150.97 255.3 154.41 254.81 155.11 249.84 151.66 250.31 150.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.2 158 264.98 161.74 264.41 162.45 259.66 158.71 260.2 158",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.65 165.62 274.2 169.63 273.55 170.34 269.04 166.33 269.65 165.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.63 173.78 282.92 178.07 282.21 178.76 277.94 174.49 278.63 173.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.07 182.5 291.09 187.05 290.38 187.66 286.36 183.15 287.07 182.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.97 191.72 298.7 196.5 298 197.03 294.26 192.29 294.97 191.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.29 201.39 305.74 206.39 305.04 206.85 301.59 201.89 302.29 201.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.02 211.48 312.16 216.68 311.48 217.07 308.34 211.91 309.02 211.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.13 221.96 317.94 227.34 317.29 227.67 314.47 222.32 315.13 221.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.59 232.79 323.07 238.33 322.45 238.59 319.95 233.09 320.59 232.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.39 243.93 327.53 249.6 326.94 249.82 324.78 244.17 325.39 243.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.5 255.34 331.29 261.13 330.74 261.3 328.93 255.53 329.5 255.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.9 266.98 334.34 272.87 333.83 272.99 332.37 267.12 332.9 266.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.59 278.8 336.64 284.77 336.23 284.84 335.11 278.9 335.59 278.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.51 290.77 338.2 296.8 337.94 296.82 337.18 290.82 337.51 290.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.7 302.84 339.03 308.89 338.92 308.89 338.52 302.85 338.7 302.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.18 315.04 339.18 318.04 339.14 315.04 339.18 315.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.78 304.59 295.55 304.59 295.55 249.41 328.16 228.7 360.78 249.41 360.78 304.59",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.78 304.59 295.55 304.59 295.55 249.41 328.16 228.7 360.78 249.41 360.78 304.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.11 295.81 299.23 295.81 299.23 221.52 342.2 221.52 357.11 235.68 357.11 295.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.2 221.52 357.11 235.68 342.2 235.68 342.2 221.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 233.99,
    width: 32.18,
    height: 1.91,
    transform: "translate(641.93 469.88) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 238.8,
    width: 32.18,
    height: 1.91,
    transform: "translate(641.93 479.51) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 243.62,
    width: 32.18,
    height: 1.91,
    transform: "translate(641.93 489.14) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 248.43,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 498.77) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 253.25,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 508.4) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 258.06,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 518.03) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 262.88,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 527.66) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 267.69,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 537.29) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 272.51,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 546.92) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 277.32,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 556.55) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 282.14,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 566.18) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.88,
    y: 286.95,
    width: 47.14,
    height: 1.91,
    transform: "translate(656.9 575.81) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,263.22v41.37H295.55V263.22c2.81,1.59,5.56,3.25,8.33,4.88s5.52,3.31,8.27,5q4.58,2.79,9.16,5.66l.09-.06a.46.46,0,0,1-.07.07l6.84,4.28c2.28-1.43,4.56-2.87,6.84-4.28l-.08-.07.1.05c3.05-1.9,6.09-3.79,9.16-5.66q4.11-2.52,8.26-5C355.23,266.47,358,264.81,360.78,263.22Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,263.22c-2.63,1.85-5.32,3.63-8,5.45s-5.36,3.56-8.05,5.33-5.63,3.66-8.46,5.47l-.25.18-7.51,4.79-.38.23-.36-.23-7.5-4.8-.27-.17q-4.25-2.72-8.46-5.48c-2.68-1.76-5.37-3.54-8-5.32s-5.34-3.6-8-5.45c2.81,1.59,5.56,3.25,8.33,4.88s5.52,3.31,8.27,5q4.58,2.79,9.16,5.66h0l6.84,4.28c2.28-1.43,4.56-2.87,6.84-4.28l0,0c3.05-1.9,6.09-3.79,9.16-5.66q4.11-2.52,8.26-5C355.23,266.47,358,264.81,360.78,263.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,278.7a.46.46,0,0,1-.07.07l-1,.87c-1.64,1.38-3.31,2.7-5,4-2.07,1.58-4.2,3.1-6.34,4.61s-4.3,2.95-6.5,4.36-4.43,2.79-6.73,4.06c2-1.74,4-3.35,6.11-4.93s4.22-3.11,6.34-4.62,4.31-2.95,6.51-4.36c1.76-1.13,3.54-2.24,5.36-3.28l1.28-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,296.66c-2.31-1.27-4.54-2.65-6.73-4.06s-4.36-2.88-6.52-4.36-4.26-3-6.33-4.61c-1.7-1.29-3.37-2.6-5-4l-1-.88-.08-.07.1.05,1.27.72c1.83,1,3.6,2.15,5.36,3.28,2.21,1.41,4.36,2.88,6.51,4.36s4.26,3,6.33,4.62S358.65,294.92,360.63,296.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tool--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,132a13.53,13.53,0,0,1,13.87-3.26l-7.83,7.83,2.75,5.78,5.78,2.75,7.83-7.84A13.53,13.53,0,1,1,281,132Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,194.29a13.52,13.52,0,0,1-13.87,3.25l7.83-7.83-2.75-5.77-5.77-2.75L234.59,189a13.53,13.53,0,1,1,22.4,5.27Z",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.44,
    y: 139.15,
    width: 12.06,
    height: 49.04,
    transform: "translate(342.58 469.24) rotate(-135)",
    style: {
      fill: "#66B436"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.07,
    cy: 126.6,
    r: 41.92,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 2.88, 256.58)",
    style: {
      fill: "#66B436"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.99,
    cy: 127.53,
    r: 40,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.99,
    cy: 127.53,
    r: 37.47,
    transform: "translate(14.26 270.55) rotate(-85.3)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,119.58c-17.06,10.34-45.11,27.3-60.78,36.6a37.46,37.46,0,0,1-10.24-13.77l51.84-48A37.47,37.47,0,0,1,190.61,119.58Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,128.84A37.33,37.33,0,0,1,189,141l-46.74,22.1a38.11,38.11,0,0,1-5.9-2.53C150.44,152.43,176.24,137.58,191.44,128.84Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.63,
    y: 92.78,
    width: 0.72,
    height: 5.68,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 97.05,
    width: 0.72,
    height: 5.68,
    transform: "translate(-31.45 82.39) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.99,
    y: 108.74,
    width: 0.72,
    height: 5.68,
    transform: "translate(-33.46 165.2) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.24,
    y: 127.17,
    width: 5.68,
    height: 0.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.51,
    y: 143.13,
    width: 5.68,
    height: 0.72,
    transform: "translate(-54.82 82.42) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.19,
    y: 154.81,
    width: 5.68,
    height: 0.72,
    transform: "translate(-65.34 197.23) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.63,
    y: 156.61,
    width: 0.72,
    height: 5.68,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 152.33,
    width: 0.72,
    height: 5.68,
    transform: "translate(-54.82 105.76) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.27,
    y: 140.65,
    width: 0.72,
    height: 5.68,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -33.46, 229.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.06,
    y: 127.17,
    width: 5.68,
    height: 0.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.79,
    y: 111.21,
    width: 5.68,
    height: 0.72,
    transform: "translate(-31.46 105.79) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.11,
    y: 99.53,
    width: 5.68,
    height: 0.72,
    transform: "translate(-1.49 197.2) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.53 95.35 155.77 130.06 152.21 130.02 153.57 95.34 154.53 95.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.15 115.43 152.8 130.33 151.1 127.21 175.69 114.58 176.15 115.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,127.53a1.21,1.21,0,1,1-1.21-1.21A1.22,1.22,0,0,1,155.2,127.53Z",
    style: {
      fill: "#66B436"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.13,239.07a30.28,30.28,0,0,1-50.59,19.15l-15.15,2.22L220,247.35a30.28,30.28,0,1,1,58.16-8.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,239.07A30.6,30.6,0,0,1,272,254.42a32.71,32.71,0,0,1-2.74,3.15,31.82,31.82,0,0,1-3.2,2.71,29.85,29.85,0,0,1-19.66,6.09,25.79,25.79,0,0,1-4.19-.44,30.5,30.5,0,0,1-15-7.39l.36.11L212.47,261l-1.1.17.56-1,7.53-13.12,0,.52a30.62,30.62,0,0,1,1.87-27,31,31,0,0,1,9.48-10.09,30.53,30.53,0,0,1,12.92-4.85,30.19,30.19,0,0,1,25.37,8.42A30.47,30.47,0,0,1,278.13,239.07Zm0,0a30,30,0,0,0-34.34-32.77,29.85,29.85,0,0,0-12.51,4.94,31.25,31.25,0,0,0-9.06,9.88,30,30,0,0,0-3.84,12.81,30.31,30.31,0,0,0,2.13,13.19l.11.27-.14.25-7.63,13.07-.54-.8,15.16-2.12.21,0,.15.14a29.85,29.85,0,0,0,14.5,7.47,27,27,0,0,0,4.11.5,29.08,29.08,0,0,0,12.23-1.79,27.87,27.87,0,0,0,7.3-3.94,27.24,27.24,0,0,0,5.95-5.79A30.53,30.53,0,0,0,278.13,239.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.89,236.84a3.67,3.67,0,1,1-3.67-3.67A3.66,3.66,0,0,1,264.89,236.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.75,236.84a3.67,3.67,0,1,1-3.66-3.67A3.66,3.66,0,0,1,251.75,236.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,236.84a3.67,3.67,0,1,1-3.67-3.67A3.66,3.66,0,0,1,238.62,236.84Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIllustration);
export default __webpack_public_path__ + "static/media/sidebar-illustration.d51bdc6f4e775453938e42b2278ab6ee.svg";
export { ForwardRef as ReactComponent };